var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        height: 350,
        width: 630,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "21",
          y: "0",
          rx: "3",
          ry: "3",
          width: "100",
          height: "15",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "21",
          y: "100",
          rx: "3",
          ry: "3",
          width: "588.5",
          height: "235",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "485",
          y: "20",
          rx: "3",
          ry: "3",
          width: "60",
          height: "18",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "21",
          y: "24",
          rx: "3",
          ry: "3",
          width: "413",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "21",
          y: "32",
          rx: "3",
          ry: "3",
          width: "355",
          height: "6",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "21",
          y: "58",
          rx: "1",
          ry: "1",
          width: "147",
          height: "19",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "175",
          y: "63",
          rx: "3",
          ry: "3",
          width: "74",
          height: "6.66",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "257",
          y: "58",
          rx: "1",
          ry: "1",
          width: "130",
          height: "19",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "550",
          y: "20",
          rx: "3",
          ry: "3",
          width: "60",
          height: "18",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }